import {
  EMAIL_INVALID,
  EMAIL_REQUIRED,
  PASSWORD_LETTERS_NUMBERS,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_NO_WHITESPACE,
  PASSWORD_ONE_NUMBER,
  PASSWORD_REQUIRED,
} from '@/constants/MessageConstants'
import * as Yup from 'yup'

import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from '@/constants/Common'

const ExternalSignInValidationSchema = Yup.object().shape({
  email: Yup.string().email(EMAIL_INVALID).required(EMAIL_REQUIRED),
  password: Yup.string()
    .required(PASSWORD_REQUIRED)
    .matches(/^\S*$/, PASSWORD_NO_WHITESPACE)
    .min(MIN_PASSWORD_LENGTH, PASSWORD_MIN_LENGTH)
    .max(MAX_PASSWORD_LENGTH, PASSWORD_MAX_LENGTH)
    .matches(/^(?=.*[a-zA-Z])/, PASSWORD_LETTERS_NUMBERS)
    .matches(/^(?=.*[0-9])(?=.{6,})/, PASSWORD_ONE_NUMBER),
  enableTermsAndConditions: Yup.boolean().required(),
})

export default ExternalSignInValidationSchema
